export const checkDisabledReviews = (product: Entity.Product): boolean => {
  if (typeof product?.reviewsDisabled === "boolean") {
    return product.reviewsDisabled;
  }
  return true;
};
